import { z } from 'zod';

/* The honest-progress contract (ARCHITECTURE §9): everything slower than
   300 ms is a named-step, streamed, cancellable job. */

export const zJobStepState = z.enum(['pending', 'running', 'done', 'failed', 'skipped']);
export const zJobStep = z.object({
  name: z.string(),
  state: zJobStepState,
  detail: z.string().optional(),
  progress: z.number().min(0).max(1).optional(),
});
export type JobStep = z.infer<typeof zJobStep>;

export const zJobState = z.enum(['queued', 'running', 'done', 'failed', 'cancelled']);
export const zJob = z.object({
  id: z.string(),
  type: z.string(),                    // e.g. 'optimize.noRegret'
  state: zJobState,
  steps: z.array(zJobStep),
  cancellable: z.boolean().default(true),
  startedAt: z.string().optional(),
  finishedAt: z.string().optional(),
  error: z.string().optional(),
  /** type-specific payload reference (result id, etc.) */
  resultRef: z.string().optional(),
});
export type Job = z.infer<typeof zJob>;
